import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/modifier-categories`, {params})
    },
    create(params) {
        return Vue.axios.post(`/modifier-categories/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/modifier-categories/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/modifier-categories/remove/${id}`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
